import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import * as moment from 'moment';

const AdvancePaymentNew = ({
  data,
  handleValue,
  getTag,
  imageUploadUrl,
  getTagById,
  prefilledData,
  handleAdvancePaySubmit
}) => {
  
  const {
   tags
  } = data;
 
  const [inputListAd, setInputListAd] = useState([{ installation_amt:"0",cartage_amt:"0",rental_charge: "0", tag_charge: "0",adv_amount:"0",payment_mode:"",capex_charge:"" ,reference_number:"",tds_check:"",tds_amt:"",remark:"",gst_amt:"",payment_photo:"",payment_photo_old:"" ,adv_payment_date:"",status:"",trans_amount:""}]);
  const [payData, setPayData] = useState();
  const [isTarget, setIsTarget] = useState(1);
  const [isFocus1, setIsFous1] = useState(true);
  const [iCheck, setICheck] = useState('Yes');

  useEffect(() => {
    if (
      prefilledData?.leadAdvPayment !== undefined &&
      prefilledData?.leadAdvPayment !== null &&
      prefilledData?.leadAdvPayment !== []
    ) {
      const {
        leadAdvPayment
      } = prefilledData;
      if (Object.keys(prefilledData.leadAdvPayment).length !== 0) {
        setTimeout(() => {
          setInputListAd(leadAdvPayment);
        }, 200);
              
              setIsTarget(1);
      }
    }
  }, [prefilledData]);
  
  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    // setInputListAd({
    //   ...inputListAd,
    //   adv_payment_date: selectedDate,
    // });
    // const list = [...inputListAd];
    //     list[index][name] = value;
    //     setInputListAd(list);
    
  };

      // handle input change
    const handleInputChange = (e, index) => {
      const re = /^[0-9\b]+$/;
      if (e.target.value === '' || re.test(e.target.value)) {
        const { name, value } = e.target;
        const list = [...inputListAd];
        list[index][name] = value;
        setInputListAd(list);
      }
      else{
        return;
      }
     
    };
    const handleDateChange = (e, index,name) => {
      const current_datetime = moment(e).format("YYYY-MM-DD");
      const list = [...inputListAd];
      list[index][name] = current_datetime;
      setInputListAd(list);
      
    };
    const handledropDownChange = (e, index,name) => {
      // console.log(e);
      const { value,id} = e;
      const list = [...inputListAd];
      list[index][name] = id;
      setInputListAd(list);
    };

    const handleConstInput = (e, index,name) => {
      // console.log(e);
      const list = [...inputListAd];
      list[index][name] = e;
      setInputListAd(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {
      const list = [...inputListAd];
      list.splice(index, 1);
      setInputListAd(list);
    };
    // handle click event of the Add button
    const handleAddClick = () => {
      setInputListAd([...inputListAd, { installation_amt:"0",cartage_amt:"0",rental_charge: "0", tag_charge: "0",adv_amount:"0",payment_mode:"",capex_charge:"" ,reference_number:"",tds_check:"",tds_amt:"",remark:"",gst_amt:"",payment_photo:"",payment_photo_old:"" ,adv_payment_date:"",status:"",trans_amount:"" }]);
    };

    const handleFirstTime = () => {
      setIsTarget(1);
    };

    const handleRemoveAll = () =>{
      setIsTarget(0);
      setInputListAd([]);
    }


    const handleFormData = () => {
      if (inputListAd && iCheck==='Yes') {
        handleValue({
          isAdv: iCheck,
          advData: inputListAd,
        });
        
      } else {
        handleValue({
          isAdv: iCheck,
          advData: null,
        });
      }
    };
  
    useEffect(() => {
      handleFormData();
    }, [inputListAd,iCheck]);



    const advancePayment = () =>{

      return (
        <>
        {inputListAd.map((x, i) => {
          return (
            <div key={i}>
              <div className="row">
                <div className="col-md-6">
                    <DropDownInput
                
                      label={localization.paymentMode}
                      data={[
                        { id: 'Cash', name: 'Cash' },
                        { id: 'Cheque', name: 'Cheque' },
                        { id: 'NEFT', name: 'NEFT' },
                        { id: 'IMPS', name: 'IMPS' },
                        { id: 'RTGS', name: 'RTGS' },
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          payment_mode: val.id,
                        });
                        handledropDownChange(val,i,'payment_mode');
                      }
                      }
                      // onChange={e => handleInputChange(e, i)}
                      value={x?.payment_mode}
                      isStarRequired={true}
                  />
            
                </div>
                <div className="col-md-6">
                <ConstantInput
                  label={localization.transAmount}
                  type='number'
                  // value={locationData.billGeoState}
                  placeholder='As mentioned on Cheque'
                  handleChange={(val) => {
                    setPayData({
                      ...inputListAd,
                      trans_amount: val,
                    });
                    handleConstInput(val,i,'trans_amount');
                  }}
                  value={x?.trans_amount}
                  required
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  
                />
                </div>
                <div className="col-md-6">
                <ConstantInput
                  label={localization.referenceNumber}
                  // value={locationData.billGeoState}
                  handleChange={(val) => {
                    setPayData({
                      ...inputListAd,
                      reference_number: val,
                    });
                    handleConstInput(val,i,'reference_number');
                  }}
                  value={x?.reference_number}
                  placeholder='Cheque & Reference Number'
                  required
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                />
               </div>
               <div className="col-md-6">
               <FormGroup
                className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
                >
              <label>
                  {localization.transactionDate}
                  <span className="label-star" style={{ color: 'red' }}>
                    {' '}
                    *{' '}
                  </span>
                </label>
                <DatePickerInput
                    // onChange={handleDateChange1}
                    onChange={e => handleDateChange(e, i,'adv_payment_date')}
                    // onShow={() => setIsFous1(true)}
                    autoClose
                    closeOnClickOutside
                    showOnInputClick
                    locale="en"
                    className="my-custom-datepicker-component"
                    // minDate={new Date()}
                    required
                    format="DD-MM-YYYY"
                    displayFormat="DD-MM-YYYY"
                    returnFormat="YYYY-MM-DD"
                    value={x?.adv_payment_date}
                  />
                  {!isFocus1 && (
                    <label className="error date_error">
                      {localization.transactionDate}
                    </label>
                  )}
               </FormGroup>
               </div>

              </div>
              <div className="row">
              {x.payment_mode && (x.payment_mode == 'Cash' || x.payment_mode == 'Cheque') && (
                <div className="col-md-6">
                  <DropDownInput
              
                    label={localization.status}
                    data={[
                      { id: 'Deposited in Bank', name: 'Deposited in Bank' },
                      { id: 'Collected from Client', name: 'Collected from Client' },
                      { id: 'Deposited to Finance', name: 'Deposited to Finance' },
                    ]}
                    required
                    errorMsg={localization.paymentMode}
                    getIdValue={(val) =>{
                      setPayData({
                        ...payData,
                        status: val.id,
                      });
                      handledropDownChange(val,i,'status');
                    }}
                    value={x?.status}
                    // onChange={e => handleInputChange(e, i)}
                    
                    isStarRequired={true}
                />
        
              </div>
              )}
              {x.payment_mode && (x.payment_mode == 'NEFT' || x.payment_mode == 'IMPS' || x.payment_mode == 'RTGS') && (
              <div className="col-md-6">
                    <DropDownInput
                
                      label={localization.status}
                      data={[
                        { id: 'Online Transaction by Client', name: 'Online Transaction by Client' },
                      ]}
                      required
                      errorMsg={localization.paymentMode}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          status: val.id,
                        });
                        handledropDownChange(val,i,'status');
                      }
                      }
                      // onChange={e => handleInputChange(e, i)}
                      
                      isStarRequired={true}
                  />
            
                </div>
              )}
              </div>


            <div className="row">
              {/* Conditionally hide fields when commercial_type_id == 5 and capex_invoice_module exists */}
              {!(data?.commercialData?.commercial_type_id == 5 && prefilledData?.capex_invoice_module) && (
              <div className="col-4">
              <label> {localization.installationCharge}<span style={{ color: 'red' }}>*</span>
              </label>
              
              <input
                  className="form-control"
                  name="installation_amt"
                  // placeholder={localization.installationCharge}
                  value={x.installation_amt}
                  onChange={e => handleInputChange(e, i)}
                />
               
              </div>
              )}
              {/* Cartage cost */}
              {!(data?.commercialData?.commercial_type_id == 5 && prefilledData?.capex_invoice_module) && (
              <div className="col-2">
              <label> {localization.cartage_amount}</label>
              <input
                  className="form-control"
                  name="cartage_amt"
                  // placeholder={localization.installationCharge}
                  value={x.cartage_amt}
                  onChange={e => handleInputChange(e, i)}
                  //required
                />
               
               </div>
               )}
               {( (data.commercialData.commercial_type_id === 6 || data.commercialData.commercial_type_id === 7) &&  <div className="col-2">
               <label> {localization.rentalCharge}</label>
              <input
                  className="form-control"
                  name="rental_charge"
                  // placeholder={localization.rentalCharge}
                  value={x.rental_charge}
                  onChange={e => handleInputChange(e, i)}
                />
              </div>)}
              
              {(data.commercialData.commercial_type_id == 5 && <div className="col-2">
               <label> {localization.capexCharge}</label>
                <input
                    className="form-control"
                    name="capex_charge"
                    // placeholder={localization.capexCharge}
                    value={x.capex_charge}
                    onChange={e => handleInputChange(e, i)}
                  />
               </div>
               )}
               
               {!(data?.commercialData?.commercial_type_id == 5 && prefilledData?.capex_invoice_module) && (
               <div className="col-2">
               <label> {localization.tagCharge}</label>
                
                <input
                    className="form-control"
                    name="tag_charge"
                    // placeholder={localization.tagCharge}
                    value={x.tag_charge}
                    onChange={e => handleInputChange(e, i)}
                  />
               </div>
               )}
                
               <div className="col-2">
               <label> {localization.amount}</label>
               <input
                    className="form-control"
                    name="adv_amount"
                    // placeholder={localization.amount}
                    value={(Number(x.installation_amt)+Number(x.rental_charge)+Number(x.capex_charge)+Number(x.tag_charge)+Number(x.cartage_amt))}
                    onBlur={e => handleInputChange(e, i)}
                    disabled
                  />
                {/* <ConstantInput
                  label={localization.amount}
                  disabled
                  value={(x.tag_charge+x.capex_charge)}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      adv_amount: val,
                    });
                  }}
                /> */}
               </div>
               </div>
               <br/>
               <div className="row">
    
               <div className="col-md-6">
               
               <DropDownInput
                
                      label={localization.tdsAmount}
                      data={[
                        { id: 'Yes', name: 'Yes' },
                        { id: 'No', name: 'No' },
                      ]}
                      required
                      errorMsg={localization.tdsAmount}
                      getIdValue={(val) =>{
                        setPayData({
                          ...payData,
                          tds_check: val.id,
                        });
                        handledropDownChange(val,i,'tds_check');
                      }
                      }
                      value={x?.tds_check}
                      // onChange={e => handleInputChange(e, i)}
                      
                      isStarRequired={true}
                  />
               </div>
              <div className="col-md-6">
              {x.tds_check && x.tds_check == 'Yes' && (
                <ConstantInput
                  label={localization.tdsAmount}
                  // value={locationData.billGeoState}
                  handleChange={(val) => {
                    setPayData({
                      ...payData,
                      tds_amt: val,
                    });
                    handleConstInput(val,i,'tds_amt');
                  }}
                  value={x?.tds_amt}
                  
                />
              )}
               </div>
              
              </div>
              <div className="row">
                <div className="col-md-6">
                <ConstantInput
                    label={localization.remarks}
                    // value={locationData.billGeoState}
                    handleChange={(val) => {
                      setPayData({
                        ...payData,
                        remark: val,
                      });
                      handleConstInput(val,i,'remark');
                    }}
                    value={x?.remark ? x?.remark : ''}
                    
                  />
                </div>
               <div className="col-md-6">
               <FileUpload
                        id={"uploadAdvPay"+i}
                        multiple
                        accept="image/*"
                        documentUploadUrl={imageUploadUrl}
                        
                        onChange={(val) => {
                          // setPayData({ ...payData, payment_photo: val.toString() })
                          handleConstInput(val.toString(),i,'payment_photo');
                        }}
                        prefilledFilename={x.payment_photo_old?x.payment_photo_old:x.payment_photo?x.payment_photo:''}
                        fileUrl={Array.isArray(x.payment_photos) ? x.payment_photos[0] : (x.payment_photos || null)}
                      >
                        <span className="btn btn-transparent">
                          {localization.uploadPaymentPhotos}
                        </span>
                      </FileUpload>
                 </div>
               
               
              <div className="btn-box d-flex">
                {inputListAd.length !== 1 && <button
                  // className="mr10"
                  onClick={() => handleRemoveClick(i)} className="btn btn-sm btn-danger mr-1">Remove</button>}
                {inputListAd.length - 1 === i && <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>}
              </div>
              <hr/>
            </div>
            </div>
          );
        })} 
        </>
      );
    };

    const handleAdvancePayment = (value) => {
      setICheck(value);
      if(value === 'Yes') {
        setIsTarget(1);
      }
      if(value === 'No') {
        setIsTarget(0);
      }
  }


  return (
    <Fragment>
      {/* <FormSection title={localization.advancePayment}> */}
      {/* <div className='mk-line-b mt-2 mb-2'></div> */}
     <div className='card'>
        <div className='card-header n-card'>
        <div className='row'>
            <div className='col-md-3'>{`Advance Payment`}</div>
            <div className='col-md-3 d-flex'>
                <input
                    onChange={(e) =>
                        handleAdvancePayment(e.target.value)
                    }
                    value={`Yes`}
                    type="radio"
                    id={`existing_client`}
                    checked={iCheck === 'Yes' ? true : false}
                    name={`Yes`}
                    className="mx-1"
                />
                <span className='com-span-x'>Yes</span>
            </div>
            <div className='col-md-3 d-flex'>
                <input
                    onChange={(e) => 
                        handleAdvancePayment(e.target.value)
                    }
                    value={`No`}
                    type="radio"
                    id={`new_client`}
                    checked={iCheck === 'No' ? true : false}
                    name={`No`}
                    className="mx-1"
                />
                <span className='com-span-x'>No</span>
            </div>
        </div>
        </div>
        <div className='card-body'>
        
        { (isTarget == 1 && (
          advancePayment()
        ))
        }
        {isTarget === 0 && 
          <div className='text-center red'>No advance payment.</div>
        }
        {/* {isTarget !== 1 &&
          <div className="form-btn full-width">
            <button className="btn btn-primary"  onClick={handleFirstTime}>Add</button>
          </div>
        } */}
        </div>
        </div>
        <div className='mt-2'></div>
          <div className='col-md-12 text-right'>
          <button onClick={() => handleAdvancePaySubmit()} className='btn btn-theme mb-2 btn-sm'>Submit</button>
        </div>
      
    </Fragment>
  );
};
AdvancePaymentNew.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
  handleAdvancePaySubmit: PropTypes.func
};
export default AdvancePaymentNew;
